import { useQuery } from "@tanstack/react-query";
import { useAppContext } from "AppContext";
import SimpleLoader from "components/SimpleLoader";
import { useAppSelector } from "hooks/useToolkit";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { RootState } from "services/redux/store";
import axiosInstance from "utils/axiosInstance";
import { MF_ONLY_PHONES } from "utils/mfOnlyUsers";

function PrivateRoute() {
  const { isAuthenticated } = useAppSelector(
    (state: RootState) => state.AuthenticationReducer
  );

  const {
    dispatch,
    state: { currentUser },
  } = useAppContext();
  const location = useLocation();

  const { isFetching } = useQuery({
    queryKey: ["CURRENT_USER"],
    queryFn: () => axiosInstance.get("/user-details/"),
    onSuccess: (response) => {
      dispatch({ type: "CURRENT_USER", data: response?.data?.data });
    },
  });

  if (isFetching) return <SimpleLoader />;

  if (
    isAuthenticated &&
    MF_ONLY_PHONES.includes(currentUser?.phone) &&
    !location.pathname.startsWith("/app/mf")
  ) {
    return <Navigate to="/app/mf" replace />;
  }

  return isAuthenticated ? <Outlet /> : <Navigate to="/" />;
}

export default PrivateRoute;
